import type { ProjectId } from 'owa-timestream-types';

export default function isTemplateProject(projectId: ProjectId): boolean {
    return projectId.indexOf('template') >= 0;
}
